module.exports = __webpack_public_path__ + "img/join_4.d840d24a.png";